module.exports = __webpack_public_path__ + "static/media/peach.0960505b.png";